var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 52 52",
    style: {
      enableBackground: "new 0 0 52 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{display:inline;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st4{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{display:inline;fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st8{fill:none;stroke:#000000;stroke-width:4;stroke-linecap:round;stroke-miterlimit:10;}\n\t.st9{stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st10{fill:none;stroke:#000000;stroke-width:2;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st11{fill:none;stroke:#000000;stroke-width:4;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st12{stroke:#000000;stroke-width:0.4;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st13{stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st14{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st15{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:0.1032,4.127;}\n\t.st16{display:inline;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st17{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stroke",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M20,35c0,1,1,2,2,2h8c1.0263,0,2-1.2303,2-2v-9c0-2.0526-1.6908-4-4-4h-4c-2.3092,0-4,1.6988-4,4V35z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st7",
    cx: 26,
    cy: 12,
    r: 6
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "23,37 20,41 22,46  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "29,37 32,41 30,46  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 20,
    y1: 25,
    x2: 14,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 32,
    y1: 25,
    x2: 38,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "st10",
    x1: 32,
    y1: 29,
    x2: 20,
    y2: 29
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "filled"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 12,
    r: 7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,35v-5H19v5c0,1.243,0.9515,2.4177,2.1267,2.8317l-1.9265,2.5687c-0.2095,0.2783-0.2583,0.6465-0.1289,0.9707l2,5 C21.228,46.7627,21.6035,47,22.0005,47c0.1235,0,0.249-0.0225,0.3711-0.0713c0.5127-0.2051,0.7622-0.7871,0.5571-1.2998 l-1.7915-4.4785L23.4996,38h5.0009l2.3624,3.1504l-1.7915,4.4785c-0.2051,0.5127,0.0444,1.0947,0.5571,1.2998 C29.7505,46.9775,29.876,47,29.9995,47c0.397,0,0.7725-0.2373,0.9292-0.6289l2-5c0.1294-0.3242,0.0806-0.6924-0.1289-0.9707 l-1.9352-2.5803C32.0643,37.366,33,36.0734,33,35z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,26.387l4.6836,1.5612C37.7886,27.9834,37.8955,28,38,28c0.4189,0,0.8091-0.2646,0.9487-0.6836 c0.1748-0.5244-0.1084-1.0908-0.6323-1.2646l-5.6778-1.8926C31.903,22.3126,30.1057,21,28,21h-4 c-2.1948,0-3.9623,1.2805-4.6647,3.1678l-5.6517,1.8839c-0.5239,0.1738-0.8071,0.7402-0.6323,1.2646 C13.1909,27.7354,13.5811,28,14,28c0.1045,0,0.2114-0.0166,0.3164-0.0518L19,26.387V28h14V26.387z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfant);
export default __webpack_public_path__ + "static/media/infant.01f9c39f0233d0233d4106a430faba4d.svg";
export { ForwardRef as ReactComponent };